import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MigrationService} from "../../../../services/migration.service";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../../../../../user/user-subscription";

@Component({
    selector: 'db-benchmark-result',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './benchmark-result.component.html',
    styleUrls: ['./benchmark-result.component.scss'],
    standalone: false
})
export class BenchmarkResultComponent {

  @Input() websiteId: number;
  @Input() loading: boolean;
  @Input() isHosted: boolean;
  @Input() isTime?: boolean = false;
  @Input() isCurrent?: boolean = true;
  @Input() value: number;
  @Input() compareValue?: number;
  @Input() high: number;
  @Input() low?: number;
  @Input() userSubscription?: UserSubscription;
  @Input() demoUser?: boolean;

  constructor(
    private _migrationService: MigrationService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  public migrate(): void {
    this._migrationService.migrate(this.websiteId);
  }
}
